<template>
	<div class="con-1334 box-white mt-30px error">
		<img src="/img/frontend/calc/icon/error.svg" alt="Sikertelen rögzítés" />
		<div class="error__header">
			<h1>Valami probléma akadt</h1>

			<p>
				Tisztelt Ügyfelünk!
				<br />
				<br />
				A biztosítási ajánlat biztosítóhoz történő beküldése során hiba lépett fel, kérjük várjon szakértőnk
				jelentkezésére, kollégánk hamarosan felveszi Önnel a kapcsolatot!
				<br />
				Köszönjük megértését és türelmét!
				<br />
				<br />
				Az Eurorisk csapata
			</p>
		</div>
		<div v-if="hasWsErrors && getWsErrors.length > 0" class="errors">
			<ul>
				<li v-for="(error, index) in getWsErrors" :key="index">{{ error }}</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	computed: {
		...mapGetters('contracting', ['getWsErrors']),
		hasWsErrors() {
			return process.env.MIX_APP_ENV !== 'production';
		},
	},
};
</script>

<style lang="scss" scoped>
.error {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
	padding-left: 0;
	padding-right: 0;

	p {
		font-size: 16px;
		line-height: 24px;
	}

	&__header {
		text-align: center;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		margin-top: -70px;
		margin-bottom: 50px;

		h1 {
			font-family: Arial;
			font-style: normal;
			font-weight: bold;
			font-size: 54px;
			line-height: 40px;
			color: #1f2835;
		}
	}
}
</style>
